
    import "src/app/AppSeller/Billing/index.module.scss?farm_css_modules";
    
    export default {"balanceBox": `balanceBox-8d0eae83`}
    